import { Component } from 'react'

import ErrorBoundaryContent from './error-boundary-content'

interface IErrorBoundaryState {
  hasError: boolean
  error: { message: string }
}

type IErrorBoundaryProps = {
  children?: React.ReactNode
}

class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
  public static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  public state = {
    hasError: false,
    error: { message: '' },
  }

  public render() {
    if (this.state.hasError && this.state.error != null) {
      return <ErrorBoundaryContent errorMessage={this.state.error.message} />
    }

    return <main>{this.props.children}</main>
  }
}

export default ErrorBoundary
